"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var getSizeValue = exports.getSizeValue = R.curry(function (x, y) {
	return R.path(["theme", "sizes", x, y]);
});

var getPadding = exports.getPadding = getSizeValue("padding");
var getPaddingHorizontal = exports.getPaddingHorizontal = getPadding("horizontal");
var getPaddingVertical = exports.getPaddingVertical = getPadding("vertical");

var getMargin = exports.getMargin = getSizeValue("margin");
var getMarginHorizontal = exports.getMarginHorizontal = getMargin("horizontal");
var getMarginLeft = exports.getMarginLeft = getMargin("left");
var getMarginRight = exports.getMarginRight = getMargin("right");
var getMarginVertical = exports.getMarginVertical = getMargin("vertical");

var getPadding2 = exports.getPadding2 = function getPadding2(theme) {
	return getPaddingVertical(theme) + "em " + getPaddingHorizontal(theme) + "em ";
};

var getMargin2 = exports.getMargin2 = function getMargin2(theme) {
	return getMarginVertical(theme) + "em " + getMarginHorizontal(theme) + "em ";
};

var getArrowWidth = exports.getArrowWidth = R.path(["theme", "sizes", "arrowWidth"]);
var getBorderRadius = exports.getBorderRadius = R.path(["theme", "sizes", "borderRadius"]);

var getColor = exports.getColor = function getColor(x) {
	return R.path(["theme", "colors", x]);
};

//# sourceMappingURL=getters.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/getters.js
// module id = 74
// module chunks = 0